<template>
  <div>
    <breadcrumbs></breadcrumbs>

    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      职位管理
    </div>

    <el-form
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="输入搜索">
        <el-input v-model="jobName" placeholder="请输入职位名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchaxu">查询</el-button>
        <el-button @click="getchonz">重置</el-button>
      </el-form-item>
    </el-form>

    <btns @exec="exec"></btns>

    <div class="adc"></div>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="职位名称" prop="jobName"> </el-table-column>

      <el-table-column label="职位人员数" prop="num">
        <template slot-scope="scope">
          <div>{{ scope.row.num + 0 }}</div>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" prop="addtime"> </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <!-- <el-link style="margin: 0 10px" type="primary" @click="addc">新增</el-link> -->
          <el-link
            style="margin: 0 10px"
            type="primary"
            @click="getabdf(scope.row.jobName, scope.row.jobId)"
            >编辑</el-link
          >
          <el-link
            style="margin: 0 10px"
            type="primary"
            @click="getchakxq(scope.row.jobId)"
            >查看详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="mgt-10 pd-0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searlist.curPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searlist.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>

    <el-dialog
      title="编辑职位"
      :visible.sync="addORUpdateVisible1"
      width="500px"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="职位名称">
          <el-input v-model="jobName1"></el-input>
        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click.native="addORUpdateVisible1 = false">取消</el-button>
        <el-button type="primary" @click="getdda">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="新增职位"
      :visible.sync="addORUpdateVisible"
      width="500px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="职位名称">
          <el-input v-model="ruleForm.jobName"></el-input>
        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click.native="addORUpdateVisible = false">取消</el-button>
        <el-button type="primary" @click="getaddcv">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },

  data() {
    return {
      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      totalCount: 0,
      jobName: "",
      jobId: "",
      jobName1: "",
      ruleForm: {
        name: "",
        jobName: "",
      },
      value1: "",
      form: {
        name: "",
        region: "",
      },

      addORUpdateVisible: false,
      addORUpdateVisible1: false,
      tableData: [],
      searchForm: {
        name: "",
      },
    };
  },

  created() {
    this.getJobList(this.searlist.curPage, this.searlist.pageSize);
  },

  methods: {
    getabdf(naem, id) {
      this.jobName1 = naem;
      this.jobId = id;
      this.addORUpdateVisible1 = true;
    },

    getdda() {
      this.$api.activitymsg
        .getdditJob({
          jobName: this.jobName1,
          jobId: this.jobId,
        })
        .then((e) => {
          if (e.code) {
            this.$message({
              message: "添加成功",
              type: "success",
            });

            this.addORUpdateVisible1 = false;

            this.getJobList(this.searlist.curPage, this.searlist.pageSize);
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    getaddcv() {
      this.$api.activitymsg
        .getaddJob({
          jobName: this.ruleForm.jobName,
        })
        .then((e) => {
          if (e.code) {
            this.ruleForm.jobName="",
            this.$message({
              message: "添加成功",
              type: "success",
            });

            this.addORUpdateVisible = false;

            this.getJobList(this.searlist.curPage, this.searlist.pageSize);
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    add() {
      this.addORUpdateVisible = true;
    },

    getchonz() {
      (this.jobName = ""),
        this.getJobList(this.searlist.curPage, this.searlist.pageSize);
    },

    getchaxu() {
      this.getJobList(this.searlist.curPage, this.searlist.pageSize);
    },

    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getJobList(this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getJobList(v, this.searlist.pageSize);
    },

    getJobList(curr, pagesize) {
      this.$api.activitymsg
        .getJobList({
          current: curr,
          size: pagesize,
          orderNo: this.jobName,
        })
        .then((e) => {
          this.tableData = e.data;
          this.totalCount = e.totalCount;
        });
    },

    getchakxq(id) {
      // this.$router.push("/index/odds");

      this.$router.push({
        path: "/index/odds",
        query: {
          id: id,
        },
      });
    },

    addc() {
      //  this.addORUpdateVisible=true
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
  },
};
</script>

<style scoped>
.shanc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.adc {
  height: 20px;
}
</style>
